import { render, staticRenderFns } from "./FullStockIndex.vue?vue&type=template&id=6afd2c3d&scoped=true"
import script from "./FullStockIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./FullStockIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FullStockIndex.vue?vue&type=style&index=0&id=6afd2c3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afd2c3d",
  null
  
)

export default component.exports